import * as i0 from '@angular/core';
import { Component } from '@angular/core';
import { BaseIcon } from 'primeng/icons/baseicon';
const _c0 = ["data-p-icon", "chevron-left"];
let ChevronLeftIcon = /*#__PURE__*/(() => {
  class ChevronLeftIcon extends BaseIcon {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵChevronLeftIcon_BaseFactory;
      return function ChevronLeftIcon_Factory(__ngFactoryType__) {
        return (ɵChevronLeftIcon_BaseFactory || (ɵChevronLeftIcon_BaseFactory = i0.ɵɵgetInheritedFactory(ChevronLeftIcon)))(__ngFactoryType__ || ChevronLeftIcon);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ChevronLeftIcon,
      selectors: [["", "data-p-icon", "chevron-left"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      attrs: _c0,
      decls: 1,
      vars: 0,
      consts: [["d", "M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z", "fill", "currentColor"]],
      template: function ChevronLeftIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵnamespaceSVG();
          i0.ɵɵdomElement(0, "path", 0);
        }
      },
      encapsulation: 2
    });
  }
  return ChevronLeftIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ChevronLeftIcon };
